import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const taskState = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/task-state',
    app: 'task',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task-state' }
    ),
    { }
  )
)()

export { taskState, TYPES }
